<template>
  <div>
    <el-dialog ref='dialog' title="请选择数据清洗类型">
      <div class="m-t-10">
        <el-checkbox-group v-model="dealType" >
          <el-checkbox 
          v-for="type in dealTypesSource"
          :label="type.id">
          {{ type.name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="footer">
        <el-button @click="closeDialog()">取消</el-button>
        <el-button type="primary" @click="sure()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
  .el-dialog--small {
    width: 60%;
  }
  .footer {
    text-align: right;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
  }
  .selectMapName .el-form-item__content {
    float: left;
  }
</style>
  
<script>
export default {
  props: {
    dealTypesSource: {
      type: Array,
      default() {
        return []
      }
    },
    curDealType: {
      type: Array,
      default() {
        return []
      }
    },
    curfieldsIndex: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      dealType: [],
      source: [],
      index: 0
    }
  },
  created() {
  },
  methods: {
    open() {
      this.$refs.dialog.open()
      this.dealType = this.curDealType
      this.source = this.dealTypesSource
      this.index = this.curfieldsIndex
    },
    closeDialog() {
      this.$refs.dialog.close()
    },
    sure() {
      this.$emit('setCleanType', this.index, this.dealType)
      this.closeDialog()
    }
  },
  watch: {
    // curDealType() {
    //   this.dealType = this.curDealType
    //   console.log(this.dealType)
    // },
    // dealTypesSource() {
    //   this.source = this.dealTypesSource
    //   console.log(this.source)
    // },
    // curfieldsIndex() {
    //   this.index = this.curfieldsIndex
    //   console.log(this.index)
    // }
  },
  mixins: []
}
</script>



// WEBPACK FOOTER //
// cleantypeDialog.vue?1c5d37a0